var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkingCapital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 42.01C34.8423 42.01 42.0102 34.8421 42.0102 26C42.0102 17.1579 34.8423 9.98999 26.0002 9.98999C17.1582 9.98999 9.99023 17.1579 9.99023 26C9.99023 34.8421 17.1582 42.01 26.0002 42.01Z",
    fill: "#FFCF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 42.01C34.8423 42.01 42.0102 34.8421 42.0102 26C42.0102 17.1579 34.8423 9.98999 26.0002 9.98999C17.1582 9.98999 9.99023 17.1579 9.99023 26C9.99023 34.8421 17.1582 42.01 26.0002 42.01Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4805 28.71C32.4605 28.43 32.3605 28.05 32.2005 27.57C32.0405 27.09 31.8005 26.67 31.4905 26.33C31.1805 25.99 30.7205 25.63 30.1005 25.26C29.4905 24.89 28.7405 24.58 27.8705 24.35L27.1605 24.17V19.99C27.4905 20.08 27.7805 20.27 28.0305 20.57C28.4005 21.01 28.6005 21.54 28.6105 22.16H31.9305C31.8405 20.63 31.3105 19.47 30.3705 18.66C29.5205 17.94 28.4505 17.47 27.1605 17.26V15.39H26.6805H25.3005H24.8405V17.24C23.5105 17.41 22.3805 17.87 21.4405 18.64C20.4005 19.5 19.8805 20.68 19.8805 22.19C19.8805 22.94 20.0005 23.58 20.2505 24.13C20.5005 24.68 20.8705 25.12 21.3605 25.46C21.8505 25.8 22.3305 26.08 22.8105 26.28C23.2805 26.48 23.8605 26.67 24.5505 26.84C24.6605 26.87 24.7505 26.89 24.8405 26.91V31.8C24.3005 31.62 23.8405 31.33 23.4805 30.91C23.0105 30.37 22.7905 29.68 22.8005 28.84H19.4805C19.8105 32.29 21.6005 34.21 24.8405 34.6V36.63H25.3005H26.6805H27.1605V34.6C27.8605 34.52 28.5005 34.37 29.0705 34.15C29.7805 33.88 30.3405 33.56 30.7505 33.19C31.1605 32.82 31.5105 32.42 31.7905 31.98C32.0705 31.54 32.2605 31.13 32.3605 30.77C32.4605 30.4 32.5105 30.07 32.5105 29.78C32.5105 29.34 32.5005 28.99 32.4805 28.71ZM23.6805 23.03C23.3605 22.75 23.2005 22.35 23.2005 21.84C23.2005 21.22 23.4105 20.74 23.8205 20.4C24.1205 20.16 24.4605 20.01 24.8505 19.94V23.59C24.3205 23.44 23.9305 23.25 23.6805 23.03ZM28.4405 31.23C28.0605 31.52 27.6305 31.72 27.1605 31.83V27.56C27.8505 27.77 28.3505 28.01 28.6505 28.26C29.0205 28.57 29.2005 29.02 29.2005 29.61C29.2005 30.3 28.9505 30.84 28.4405 31.23Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 50.67C12.3202 50.67 1.24023 39.58 1.24023 25.91C1.24023 16.4 6.60023 8.13999 14.4702 3.98999",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 1.14001C39.68 1.14001 50.76 12.23 50.76 25.9C50.76 35.37 45.44 43.6 37.63 47.77",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33984 1L15.8598 3.47L13.3798 9.99",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3498 51L35.8398 48.53L38.3098 42.01",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingCapital);
export default __webpack_public_path__ + "static/media/WorkingCapital.71757321fd086e784f735447598e4081.svg";
export { ForwardRef as ReactComponent };